var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.65,
    height: 12.708,
    viewBox: "0 0 13.65 12.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10544"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "mail email e-mail letter"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91631",
    d: "M15.238 13a.49.49 0 0 0-.49.49v3.916a.49.49 0 0 1-.49.49H4.469a.49.49 0 0 1-.49-.49V13.49a.49.49 0 0 0-.979 0v3.916a1.471 1.471 0 0 0 1.469 1.469h9.79a1.471 1.471 0 0 0 1.469-1.469V13.49a.49.49 0 0 0-.49-.49z",
    transform: "translate(-2.538 -6.416)",
    style: {
      fill: "#6e6a65",
      stroke: "#6e6a65",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1",
    d: "M7089.364 22054.936a.473.473 0 0 1-.291-.1l-5.784-4.334h1.651l4.426 3.332 4.422-3.332h1.65l-5.779 4.334a.492.492 0 0 1-.295.1z",
    transform: "translate(-7082.538 -22044.252)",
    style: {
      fill: "#6e6a65",
      stroke: "#6e6a65",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M6.075 0a.473.473 0 0 0-.291.1L0 4.434h1.651L6.077 1.1 10.5 4.434h1.65L6.371.1a.492.492 0 0 0-.296-.1z",
    transform: "translate(.751 .25)",
    style: {
      fill: "#6e6a65",
      stroke: "#6e6a65",
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpened);
export default __webpack_public_path__ + "static/media/mail-opened.svg";
export { ForwardRef as ReactComponent };